import React from 'react';
import { Cell, HtmlTable } from '../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { formatCurrency, formatPercentage } from '../../../CommonUtils/formatNumber';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { GoalTrackDTO } from '../../api/useGoalTrackQuery';
import { formatDate } from '../../../CommonUtils/formatDate';

interface Prop {
  data: GoalTrackDTO[];
}

export const Table = ({ data }: Prop) => {
  return (
    <Box display="flex" flex={1} width="100%" mt="16">
      <HtmlTable>
        <table>
          <thead>
            <tr>
              <th>
                <Text variant="smallCaps" textAlign="right">
                  Investment goal
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  time period
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  Target Performance
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  Actual performance
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  Start value
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  Tracking value
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  current value
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  target value
                </Text>
              </th>
            </tr>
          </thead>

          <tbody>
            {data.map(
              ({
                goalName,
                targetPerformance,
                actualPerformance,
                startValue,
                trackingValue,
                targetValue,
                startDate,
                endDate,
                endValue,
              }) => (
                <tr key={goalName}>
                  <Cell>
                    <Text textAlign="right">{goalName}</Text>
                  </Cell>

                  <Cell>
                    <Text textAlign="right">
                      {formatDate(startDate)} - {formatDate(endDate)}
                    </Text>
                  </Cell>

                  <Cell>
                    <Text textAlign="right">
                      {targetPerformance
                        ? formatPercentage(targetPerformance / 100, { decimalPlaces: 2 })
                        : ''}
                    </Text>
                  </Cell>

                  <Cell>
                    <Text textAlign="right">
                      {actualPerformance
                        ? formatPercentage(actualPerformance / 100, { decimalPlaces: 2 })
                        : ''}
                    </Text>
                  </Cell>

                  <Cell>
                    <Text textAlign="right">
                      {startValue ? formatCurrency(startValue, { decimalPlaces: 2 }) : ''}
                    </Text>
                  </Cell>

                  <Cell>
                    <Text textAlign="right">
                      {trackingValue ? formatCurrency(trackingValue, { decimalPlaces: 2 }) : ''}
                    </Text>
                  </Cell>

                  <Cell>
                    <Text textAlign="right">
                      {endValue ? formatCurrency(endValue, { decimalPlaces: 2 }) : ''}
                    </Text>
                  </Cell>

                  <Cell>
                    <Text textAlign="right">
                      {targetValue ? formatCurrency(targetValue, { decimalPlaces: 2 }) : ''}
                    </Text>
                  </Cell>
                </tr>
              ),
            )}
          </tbody>
        </table>
      </HtmlTable>
    </Box>
  );
};
